import Commons from '../../../../Services/Common/Common';

/** 작업계획서 조회 SP_TBM_R5 (Global.urls.File.getFileCustomR2) */
export const M_FILE_BASIC_02_Schema = {
  mapper: {
    search1: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd),
    },
  },
};
